import Component from "../../../lib/component";
import {getDebouncedFunction} from "../../../helpers/debounce";
import ComponentEvent from "../../../lib/component_event";
import {UsernameIndicator} from "./username_indicator";

export const UsernameFieldConfig = {
    componentTypeKey: 'UsernameField',
    baseHtmlClass: 'signup_form__username_field',
    selector: '.signup_form__username_field',

    inputSelector: '.signup_form__username_field__input',
    changedUsernameEventName: 'Rankers.SignupForm:UsernameChanged',
}

export class UsernameField extends Component{

    static get config() {
        return UsernameFieldConfig;
    }

    constructor(id_or_element, signupForm) {
        super({
            element: id_or_element,
            config:  UsernameField.config
        });

        this.signupForm = signupForm;

        this.inputElement = this.element.querySelector(UsernameField.config.inputSelector);
        const debouncedHandler = getDebouncedFunction(this.handleKeyup.bind(this), 300);
        this.inputElement.addEventListener('keyup', debouncedHandler);
        this.inputElement.addEventListener('change', debouncedHandler);
        this.inputElement.addEventListener('search', debouncedHandler);
        this.inputElement.addEventListener('input', debouncedHandler);

        this.usernameIndicator = getUsernameIndicator(this);
    }

    handleKeyup(event) {
        const componentEvent = new ComponentEvent(UsernameField.config.changedUsernameEventName, {target: this});
        this.fireEvent(componentEvent, { username: this.getValue() });
        this.render();
    }

    getValue() {
        return this.inputElement.value;
    }

    render() {
        this.usernameIndicator?.render();
    }

}

function getUsernameIndicator(usernameField) {
    const element = UsernameIndicator.createElement();
    if (!element) return null;
    usernameField.element.insertBefore(element, usernameField.inputElement.nextSibling); // insert after the input element
    return new UsernameIndicator(element, usernameField, usernameField.signupForm);
}
